import { useTranslation } from "react-i18next";
import "../style/lang-switch.scss";
import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import de from "../images/flags/de.svg";
import si from "../images/flags/si.svg";
import us from "../images/flags/us.svg";
import earth from "../images/flags/globe2.png";

const language = [
  { code: "en", lang: "Eng", img: us },
  { code: "gr", lang: "Ger", img: de },
  { code: "slo", lang: "Slo", img: si },
];

function LanguageSwitch() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { i18n } = useTranslation();
  const open = Boolean(anchorEl);

  function changeLangHandle(lang) {
    i18n.changeLanguage(lang);
    setAnchorEl(null);
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className="lang-switch">
        <Button
          className="text-light btn bg-transparent border-0 lang-btn ps-lg-0"
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <img
            className="rotate me-1"
            style={{ maxWidth: "25px" }}
            src={earth}
            alt="world-icon"
            loading="lazy"
          />
          <span>Lang</span>
        </Button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          onClose={handleClose}
          open={open}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {language &&
            language.map((lan, i) => {
              return (
                <MenuItem
                  key={i}
                  className={
                    lan.code === i18n.language ? "bg-primary text-light" : ""
                  }
                  onClick={() => changeLangHandle(lan.code)}
                >
                  <img
                    style={{ maxWidth: "20px", marginRight: "4px" }}
                    src={lan.img}
                    alt="lan.lang"
                    loading="lazy"
                  />
                  <span className="lang-text">{lan.lang}</span>
                </MenuItem>
              );
            })}
        </Menu>
      </div>
    </>
  );
}

export default LanguageSwitch;
